var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "multi-options-search-ui col-md-12" }, [
      _c("div", { staticClass: "search-ui-wrapper" }, [
        _c("div", { staticClass: "type" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.parameterFocused,
                  expression: "parameterFocused",
                },
              ],
              class:
                _vm.searchParameterType == "meaning search"
                  ? "meaning-search"
                  : "",
              attrs: { id: "parameter_type" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.parameterFocused = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v(_vm._s("Select a Search Type")),
              ]),
              _vm._l(_vm.searchParameters, function (item) {
                return _c(
                  "option",
                  { key: item.parameter, domProps: { value: item.parameter } },
                  [_vm._v(_vm._s(item.label))]
                )
              }),
            ],
            2
          ),
          _vm.searchParameterType == "meaning search"
            ? _c(
                "select",
                {
                  staticClass:
                    "form-control ss-meaning-sim-score meaning-search sim-score",
                  attrs: {
                    id: "search_param_similarityThreshold",
                    title: "Similarity score",
                  },
                },
                [
                  _c("option", { attrs: { value: "0.01" } }, [_vm._v("0.01")]),
                  _c("option", { attrs: { value: "0.1" } }, [_vm._v("0.1")]),
                  _c("option", { attrs: { value: "0.2" } }, [_vm._v("0.2")]),
                  _c("option", { attrs: { value: "0.3" } }, [_vm._v("0.3")]),
                  _c("option", { attrs: { value: "0.4" } }, [_vm._v("0.4")]),
                  _c("option", { attrs: { value: "0.5", selected: "" } }, [
                    _vm._v("0.5"),
                  ]),
                  _c("option", { attrs: { value: "0.6" } }, [_vm._v("0.6")]),
                  _c("option", { attrs: { value: "0.7" } }, [_vm._v("0.7")]),
                  _c("option", { attrs: { value: "0.8" } }, [_vm._v("0.8")]),
                  _c("option", { attrs: { value: "0.9" } }, [_vm._v("0.9")]),
                  _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
                ]
              )
            : _vm._e(),
        ]),
        _vm.searchParameterType == "list" ||
        _vm.searchParameterType == "input" ||
        !_vm.searchParameterType
          ? _c("div", { staticClass: "input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.parent.paramSearch[_vm.paramIndex],
                    expression: "parent.paramSearch[paramIndex]",
                  },
                ],
                staticClass: "form-control multi-options-search-input",
                attrs: {
                  name: "multi-options-search-input",
                  id: "search_param_" + _vm.parameterFocused,
                  autoComplete: "off",
                },
                domProps: { value: _vm.parent.paramSearch[_vm.paramIndex] },
                on: {
                  focus: function ($event) {
                    return _vm.resetInput(_vm.paramIndex)
                  },
                  keyup: function ($event) {
                    _vm.parameterFocused != "" ? _vm.getValue($event) : ""
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.parent.paramSearch,
                      _vm.paramIndex,
                      $event.target.value
                    )
                  },
                },
              }),
            ])
          : _vm._e(),
        _vm.searchParameterType == "string to array" ||
        _vm.searchParameterType == "meaning search"
          ? _c("div", { staticClass: "input textarea" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.parent.paramSearch[_vm.paramIndex],
                    expression: "parent.paramSearch[paramIndex]",
                  },
                ],
                staticClass: "form-control multi-options-search-input",
                attrs: {
                  rows: "4",
                  cols: "50",
                  name: "multi-options-search-input",
                  id: "search_param_" + _vm.parameterFocused,
                  autoComplete: "off",
                },
                domProps: { value: _vm.parent.paramSearch[_vm.paramIndex] },
                on: {
                  focus: function ($event) {
                    return _vm.resetInput(_vm.paramIndex)
                  },
                  keyup: function ($event) {
                    _vm.parameterFocused != "" ? _vm.getValue($event) : ""
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.parent.paramSearch,
                      _vm.paramIndex,
                      $event.target.value
                    )
                  },
                },
              }),
            ])
          : _vm._e(),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "research-narrative-options hidden",
        class:
          _vm.searchParameterType == "string to array" ||
          _vm.searchParameterType == "meaning search"
            ? "text-area"
            : "",
        attrs: { id: "research_narrative_options" },
      },
      [
        _vm._l(_vm.contextOptions, function (option) {
          return [
            _c("div", { key: option["context id"], staticClass: "row" }, [
              _c("div", { staticClass: "col-md-10" }, [
                _c("div", [
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(option.label) },
                  }),
                ]),
                _c("div", {
                  domProps: { innerHTML: _vm._s(option.description) },
                }),
              ]),
              _c("div", { staticClass: "col-md-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-primary context-search-btn",
                    on: {
                      click: function ($event) {
                        _vm.cleanUpKeyParams(
                          _vm.parameterFocused,
                          option.sections,
                          option["context id"]
                        )
                        _vm.parent.updateSearch(
                          _vm.parameterFocused,
                          option.sections
                        )
                      },
                    },
                  },
                  [_vm._v("Search")]
                ),
              ]),
            ]),
          ]
        }),
        _c("div", { staticClass: "reset-button-container" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-success context-search-btn",
              on: {
                click: function ($event) {
                  return _vm.parent.resetSearch()
                },
              },
            },
            [_vm._v("Reset search")]
          ),
        ]),
      ],
      2
    ),
    _c(
      "div",
      {
        staticClass: "custom-select custom-select-search long-list",
        staticStyle: { right: "0" },
        style: _vm.listOptions.length == 0 ? "display:none !important;" : "",
        attrs: {
          id: "listOptions" + _vm.parameterFocused,
          size: _vm.listOptions.length >= 5 ? 5 : "auto",
        },
      },
      [
        _vm._l(_vm.listOptions, function (option) {
          return [
            _c("a", {
              key: option.value,
              staticClass: "custom-select-a-option",
              attrs: { href: "javascript:;" },
              domProps: { innerHTML: _vm._s(option.label) },
              on: {
                click: function ($event) {
                  _vm.parent.setListValue(
                    option.value,
                    _vm.parameterFocused,
                    _vm.paramIndex,
                    null
                  )
                  _vm.listOptions = []
                },
              },
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }